import { login } from './reducers/login';
import { logout } from './reducers/logout';
import { loading } from './reducers/loading';

const AuthReducer = (state, action) => {
  const { payload } = action;
  switch (action.type) {
    case 'LOGIN':
      return login(state, action.payload);
    case 'LOGOUT':
      return logout(state, action.payload);
    case 'SET_LOADING':
      return loading(state, action.payload);
    default:
      return state;
  }
};

export default AuthReducer;
